import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import headerFr from '../locales/fr/header.json';
import headerEn from '../locales/en/header.json';
import headerAr from '../locales/ar/header.json';

import commonFr from '../locales/fr/common.json';
import commonEn from '../locales/en/common.json';
import commonAr from '../locales/ar/common.json';

import footerFr from '../locales/fr/footer.json';
import footerEn from '../locales/en/footer.json';
import footerAr from '../locales/ar/footer.json';

import homePageFr from '../locales/fr/homePage.json';
import homePageEn from '../locales/en/homePage.json';
import homePageAr from '../locales/ar/homePage.json';

import aboutPageFr from '../locales/fr/aboutPage.json';
import aboutPageEn from '../locales/en/aboutPage.json';
import aboutPageAr from '../locales/ar/aboutPage.json';

import mapServicesFr from '../locales/fr/mapServices.json';
import mapServicesEn from '../locales/en/mapServices.json';
import mapServicesAr from '../locales/ar/mapServices.json';

import signalmentFr from '../locales/fr/signalment.json';
import signalmentEn from '../locales/en/signalment.json';
import signalmentAr from '../locales/ar/signalment.json';

import victimConfirmationFr from '../locales/fr/victimConfirmation.json';
import victimConfirmationEn from '../locales/en/victimConfirmation.json';
import victimConfirmationAr from '../locales/ar/victimConfirmation.json';

import profesionalesFr from '../locales/fr/profesionales.json';
import profesionalesEn from '../locales/en/profesionales.json';
import profesionalesAr from '../locales/ar/profesionales.json';

import allServicesPageFr from '../locales/fr/allServicesPage.json';
import allServicesPageEn from '../locales/en/allServicesPage.json';
import allServicesPageAr from '../locales/ar/allServicesPage.json';

import victimServicesResultsFr from '../locales/fr/victimServicesResults.json';
import victimServicesResultsEn from '../locales/en/victimServicesResults.json';
import victimServicesResultsAr from '../locales/ar/victimServicesResults.json';

import languageSelectorFr from '../locales/fr/languageSelector.json';
import languageSelectorEn from '../locales/en/languageSelector.json';
import languageSelectorAr from '../locales/ar/languageSelector.json';

import actorDetailsFr from '../locales/fr/actorDetails.json';
import actorDetailsEn from '../locales/en/actorDetails.json';
import actorDetailsAr from '../locales/ar/actorDetails.json';

import requestHelpFr from '../locales/fr/requestHelp.json';
import requestHelpEn from '../locales/en/requestHelp.json';
import requestHelpAr from '../locales/ar/requestHelp.json';

import faqPageFr from '../locales/fr/faqPage.json';
import faqPageEn from '../locales/en/faqPage.json';
import faqPageAr from '../locales/ar/faqPage.json';

import authFr from '../locales/fr/auth.json';
import authEn from '../locales/en/auth.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        common: commonFr,
        header: headerFr,
        footer: footerFr,
        homePage: homePageFr,
        aboutPage: aboutPageFr,
        mapServices: mapServicesFr,
        signalment: signalmentFr,
        victimConfirmation: victimConfirmationFr,
        profesionales: profesionalesFr,
        allServicesPage: allServicesPageFr,
        victimServicesResults: victimServicesResultsFr,
        languageSelector: languageSelectorFr,
        ServiceDetails: actorDetailsFr,
        requestHelp: requestHelpFr,
        faqPage: faqPageFr,
        auth: authFr,
      },
      en: {
        common: commonEn,
        header: headerEn,
        footer: footerEn,
        homePage: homePageEn,
        aboutPage: aboutPageEn,
        mapServices: mapServicesEn,
        signalment: signalmentEn,
        victimConfirmation: victimConfirmationEn,
        profesionales: profesionalesEn,
        allServicesPage: allServicesPageEn,
        victimServicesResults: victimServicesResultsEn,
        languageSelector: languageSelectorEn,
        ServiceDetails: actorDetailsEn,
        requestHelp: requestHelpEn,
        faqPage: faqPageEn,
        auth: authEn,
      },
      ar: {
        common: commonAr,
        header: headerAr,
        footer: footerAr,
        homePage: homePageAr,
        aboutPage: aboutPageAr,
        mapServices: mapServicesAr,
        signalment: signalmentAr,
        victimConfirmation: victimConfirmationAr,
        profesionales: profesionalesAr,
        allServicesPage: allServicesPageAr,
        victimServicesResults: victimServicesResultsAr,
        languageSelector: languageSelectorAr,
        ServiceDetails: actorDetailsAr,
        requestHelp: requestHelpAr,
        faqPage: faqPageAr,
      },
    },
    fallbackLng: 'fr',
    defaultNS: 'header',
    ns: ['common', 'header', 'footer', 'homePage', 'aboutPage', 'mapServices', 'signalment', 'victimConfirmation', 'profesionales', 'allServicesPage', 'victimServicesResults', 'languageSelector', 'ServiceDetails', 'requestHelp', 'faqPage', 'auth'],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'selectedLanguage', // Matches key used in Context (though now Context delegates to this)
    },
    react: {
      useSuspense: true, // Use suspense for loading translations
    },
  });

export default i18n;


